// src/store/slices/organization/index.ts
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectOrganizationState = (s: RootState) => s.organization;

export const selectOrganizationData = createSelector(
  selectOrganizationState,
  (state) => state.data
);

export const selectOrgLoading = createSelector(
  selectOrganizationState,
  (state) => state.loading
);

export const selectOrgError = createSelector(
  selectOrganizationState,
  (state) => state.error
);

export const selectOrgProfile = createSelector(selectOrganizationData, (data) => ({
  name: data.name,
  customerSince: data.customerSince,
  phone: data.phone,
  address: data.address,
}));

export const selectAdministrators    = createSelector(selectOrganizationData, (data) => data.administrators);
export const selectInternalSeats     = createSelector(selectOrganizationData, (data) => data.internalSeats);
export const selectExternalSeats     = createSelector(selectOrganizationData, (data) => data.externalSeats);
export const selectOrganizationUsers = createSelector(selectOrganizationData, (data) => data.organizationUsers);

export const selectOrgLoadingAny = createSelector(
  selectOrgLoading,
  (loading) => loading.profile || loading.admins || loading.seats || loading.orgUsers
);

export const selectOrgLoadingProfile = createSelector(selectOrgLoading, (loader) => loader.profile);
